module.exports = __webpack_public_path__ + "assets/img/01_taobao_100x100.7b66aefa.png";